import { Typography } from '@mui/material';
import { Box } from '@mui/material';


function About() {
  return (
    <Box className="Page About">
      <Typography variant="h3">About Page</Typography>
      <Typography variant="h3"><small>Sub-Title</small></Typography>
      {
        ['P1','P2','P3', 'P4', 'P5', 'P6', 'P7', 'P8'].map((par) => {
          return <p key={par}>Paragraph with quite a few things to say for itself 
          going on for enough words to fill most if not all of a complete line.
          Actually it's worth saying a few more things since that first sentence
          was nowhere near long enough to call itself a paragraph, a few mere words
          in fact lost in the oceans of white space {par}.</p>
        })
      }
      <Typography variant="h1">Fake Mick H1</Typography>
      <Typography variant="h1"><small>Small H1</small></Typography>
      <Typography variant="h3">Fake Mick H2</Typography>
      <Typography variant="h3">Fake Mick H3</Typography>
      <Typography variant="h3"><small>Small Fake H3</small></Typography>
      <Typography variant="h4">Fake Mick H4</Typography>
      <Typography variant="h5">Fake Mick H5</Typography>
      <Typography variant="h6">Fake Mick H6</Typography>
      <Typography variant="subtitle1">Fake Mick subtitle1</Typography>
      <Typography variant="subtitle2">Fake Mick subtitle2</Typography>


    </Box>
  );
}

export default About;

